

 <template>
  <b-field label="Buscar producto por nombre o código de barras">
    <b-autocomplete
      v-model="producto"
      id="producto"
      ref="autocomplete"
      placeholder="Escribe el nombre o el código de barras del producto"
      :keep-first="true"
      :data="productosFiltrados"
      field="nombre"
      @input="debounceBuscarProductos"
      @select="seleccionarProducto"
      size="is-large"
    >
    </b-autocomplete>
  </b-field>
</template>
  
  <script>
import Swal from "sweetalert2";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";
import HttpService from "../../Servicios/HttpService";

export default {
  name: "BuscarProducto",
  mixins: [NotificacionesMixin],

  data: () => ({
    producto: "",
    productosEncontrados: [],
    debounceTimer: null,
    productoSeleccionado: {},
  }),

  mounted() {
    this.ponerFocus();
  },

  methods: {
  seleccionarProducto(opcion) {
    if (!opcion) {
      this.mostrarSwalCrearProductoRapido();
      return;
    }

    this.productoSeleccionado = opcion;
    this.mostrarSwalEditarProducto(opcion); // Mostrar Swal para editar producto encontrado
    this.limpiarProducto();
  },

  limpiarProducto() {
    this.$nextTick(() => {
      this.producto = "";
      this.productosEncontrados = [];
      document.querySelector("#producto").focus();
    });
  },

  debounceBuscarProductos() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      const payload = {
        accion: "obtener_nombre_codigo",
        producto: this.producto,
      };

      HttpService.obtenerConConsultas("productos.php", payload).then(
        (producto) => {
          this.productosEncontrados = producto;
          if (producto.length === 0) {
            this.mostrarSwalCrearProductoRapido();
          } else {
            this.seleccionarProductoExacto();
          }
        }
      );
    }, 400);
  },

  seleccionarProductoExacto() {
    const productoExacto = this.productosFiltrados.find(
      (opcion) =>
        opcion.codigo.toString().toLowerCase() ===
        this.producto.toString().toLowerCase()
    );

    if (productoExacto) {
      this.seleccionarProducto(productoExacto);
    }
  },

  ponerFocus() {
    document.querySelector("#producto").focus();
  },

  calcularGanancia(precioCompra, precioVenta) {
    if (precioCompra > 0) {
      const ganancia = ((precioVenta - precioCompra) / precioCompra) * 100;
      return `Ganancia: ${ganancia.toFixed(2)}%`;
    }
    return "Ganancia: 0%";
  },

  mostrarSwalCrearProductoRapido() {
    Swal.fire({
      title: "Crear Producto Rápido",
      html: `
        <div>
          <label for="nombre">Nombre del Producto</label>
          <input id="nombre" class="swal2-input" placeholder="Nombre del Producto" required>
        </div>
        <div>
          <label for="precioCompra">Precio de Compra</label>
          <input id="precioCompra" class="swal2-input" placeholder="Precio de Compra" type="number" oninput="updateGanancia()">
        </div>
        <div>
          <label for="precioVenta">Precio de Venta</label>
          <input id="precioVenta" class="swal2-input" placeholder="Precio de Venta" type="number" required oninput="updateGanancia()">
        </div>
        <div>
          <label for="nombre">Existencia del Producto</label>
          <input id="existencia" class="swal2-input" placeholder="Existencia" type="number">
        </div>
        <div id="gananciaLabel">Ganancia: 0%</div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const nombre = document.getElementById("nombre").value;
        const precioCompra = parseFloat(document.getElementById("precioCompra").value) || 0;
        const precioVenta = parseFloat(document.getElementById("precioVenta").value);

        if (!nombre || isNaN(precioVenta)) {
          Swal.showValidationMessage("Nombre y Precio de Venta son obligatorios");
          return false;
        }
        if (precioVenta < precioCompra) {
          Swal.showValidationMessage("El Precio de Venta no puede ser menor al Precio de Compra");
          return false;
        }

        return {
          nombre,
          precioCompra,
          precioVenta,
          existencia: parseInt(document.getElementById("existencia").value) || 0,
          codigo: this.producto,
        };
      },
      didOpen: () => {
        window.updateGanancia = () => {
          const precioCompra = parseFloat(document.getElementById("precioCompra").value) || 0;
          const precioVenta = parseFloat(document.getElementById("precioVenta").value) || 0;
          document.getElementById("gananciaLabel").textContent = this.calcularGanancia(precioCompra, precioVenta);
        };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.crearProductoRapido(result.value);
      }
    });
  },

  mostrarSwalEditarProducto(producto) {
    Swal.fire({
      title: "Editar Producto",
      html: `
        <div>
          <label for="nombre">Nombre del Producto</label>
          <input id="nombre" class="swal2-input" value="${producto.nombre}" required>
        </div>
        <div>
          <label for="precioCompra">Precio de Compra</label>
          <input id="precioCompra" class="swal2-input" placeholder="Precio de Compra" type="number" value="${producto.precioCompra || 0}" oninput="updateGanancia()">
        </div>
        <div>
          <label for="precioVenta">Precio de Venta</label>
          <input id="precioVenta" class="swal2-input" placeholder="Precio de Venta" type="number" value="${producto.precioVenta}" required oninput="updateGanancia()">
        </div>
        <div>
          <label for="nombre">Existencia del Producto</label>
          <input id="existencia" class="swal2-input" placeholder="Existencia" type="number" value="${producto.existencia || 0}">
        </div>
        <div id="gananciaLabel">${this.calcularGanancia(producto.precioCompra || 0, producto.precioVenta)}</div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const nombre = document.getElementById("nombre").value;
        const precioCompra = parseFloat(document.getElementById("precioCompra").value) || 0;
        const precioVenta = parseFloat(document.getElementById("precioVenta").value);

        if (!nombre || isNaN(precioVenta)) {
          Swal.showValidationMessage("Nombre y Precio de Venta son obligatorios");
          return false;
        }
        if (precioVenta < precioCompra) {
          Swal.showValidationMessage("El Precio de Venta no puede ser menor al Precio de Compra");
          return false;
        }

        return {
          ...producto,
          nombre,
          precioCompra,
          precioVenta,
          existencia: parseInt(document.getElementById("existencia").value) || 0,
        };
      },
      didOpen: () => {
        window.updateGanancia = () => {
          const precioCompra = parseFloat(document.getElementById("precioCompra").value) || 0;
          const precioVenta = parseFloat(document.getElementById("precioVenta").value) || 0;
          document.getElementById("gananciaLabel").textContent = this.calcularGanancia(precioCompra, precioVenta);
        };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.actualizarProducto(result.value);
      }
    });
  },

  crearProductoRapido(producto) {
    const payload = {
      accion: "crear_producto_rapido",
      producto: { ...producto },
    };

    HttpService.registrar("productos.php", payload).then((response) => {
      if (response.success) {
        this.mostrarNotificacion("success", `Producto ${producto.nombre} creado correctamente`);
        this.limpiarProducto();
      } else {
        this.mostrarNotificacion("error", `Hubo un problema al actualizar el producto`);
      }
    });
  },

  actualizarProducto(producto) {
    const payload = {
      accion: "actualizar_producto",
      producto: { ...producto },
    };

    HttpService.registrar("productos.php", payload).then((response) => {
      if (response.success) {
        this.mostrarNotificacion("success", `Producto ${producto.nombre} actualizado correctamente`);
        this.limpiarProducto();
      } else {
        this.mostrarNotificacion("error", `Hubo un problema al actualizar el producto`);
      }
    });
  },
},

computed: {
  productosFiltrados() {
    return this.productosEncontrados.filter((opcion) => {
      const texto = this.producto.toLowerCase();
      return (
        opcion.nombre.toString().toLowerCase().includes(texto) ||
        opcion.codigo.toString().toLowerCase().includes(texto)
      );
    });
  },
},

};
</script>
